import React from "react";
import { inject, observer } from "mobx-react";
import { LightButton, StickyFooterButtons } from "best-common-react";

class UserAdminFooter extends React.Component {
  render() {
    const { userAdminStore, userBulkAllotmentStore, commonStore } = this.props.rootStore;
    let updateDisabled = userAdminStore.userIdsToUpdateAllotment.length === 0;

    return (
      <StickyFooterButtons>
        <LightButton onClick={userAdminStore.createNewUser} id="new-user">
          Create New User
        </LightButton>
        <LightButton disabled={updateDisabled} onClick={userBulkAllotmentStore.onOpen}>
          Update Ticket Allotment
        </LightButton>
        <LightButton onClick={() => userAdminStore.buildUserExport()} id="export-users">
          Export User List
        </LightButton>
      </StickyFooterButtons>
    );
  }
}

export default inject("rootStore")(observer(UserAdminFooter));
